<template>
    <v-row justify="center">
      <v-dialog
        v-model="dialogOpenLinksTec"
        persistent
        max-width="900"
        
      >

        <v-card>

      <v-card-text>
      
    <v-container class="pa-5">
        <v-row align-center justify-center fill-height>
           
            <v-col cols="12" sm="12" lg="12">
                <p class="google-font mb-1" style="font-weight: 350; color: #616161; font-size: 180%;">
                    <b>Cree fácilmente una página para visualizar todas sus
                        <span style="color: #1a73e8;">redes</span>.
                    </b>
                </p>
                <p class="google-font mt-0" style="font-size: 170%">{{ chapterDetails.ChapterName }}</p>
                <p class="google-font" style="font-size: 110%">{{ chapterDetails.ChapterShortDescription }}</p>

                
    <p class="google-font" style="font-size: 110%;color: #0D47A1;">Puede elegir posteriormente estas opciones:</p>

    <v-list dense two-line>
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="grey darken-1">mdi-lock</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Perfil privado</v-list-item-title>
          <v-list-item-subtitle class="text-wrap">
            Sin disponibilizar URL de perfil — especial para solo almacenar datos de links.
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon color="blue darken-2">mdi-link-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Perfil con acceso solo por URL</v-list-item-title>
          <v-list-item-subtitle class="text-wrap">
            Especial para usar el link en redes, sin ser listado en la vista de perfiles de TecZoa.
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon color="green darken-2">mdi-earth</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Perfil público</v-list-item-title>
          <v-list-item-subtitle class="text-wrap">
            Accesible por URL y visualizado en la página principal de TecZoa.com
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>



               <v-btn @click="openLink()" class="ma-0 google-font elevation-1" color="#1a73e8" style="text-transform: capitalize; border-radius: 5px; color: white;">
          Abrir Links Tec
        </v-btn>

         <v-btn class="mr-2"  outlined color="red darken-1"  text  @click="dialogOpenLinksTec=false">
                 <v-icon>
         mdi-cancel
        </v-icon> 
                Cerrar
              </v-btn>

            </v-col>
        </v-row>
    </v-container>
     </v-card-text>

   </v-card>





      </v-dialog>
    </v-row>
  </template>


<script>



import router from "@/router/index";






  import { 
   
  } from 'vuex'
  export default {
    name:'OpenLinksTecDialog',
   data() {
      return {
        dialogOpenLinksTec:false,


          chapterDetails: {
                ChapterName: 'Regístrese para poder gestionar fácilmente la información a disponibilizar',
                ChapterShortDescription: 'Al abrir el enlace, puede seleccionar crear un nuevo usuario, o si ya es un miembro puede seleccionar ingresar',
                ChapterHashTags: ['LinksTec', 'TecZoa', 'MagZoa'],
                ChapterMeetupLink: 'https://www.meetup.com/your-chapter',
                GDGProgramWebsite: 'https://www.google.com'
            }
      
      }
    },
    components:{

     

    },
    computed: {

    },
    methods: {

      openLink(){

        this.dialogOpenLinksTec=false;
            window.open('/linkstec', '_blank');
      },

    openDialog() {
      this.dialogOpenLinksTec = true;
    },
    

    }
  } 
</script>

